import projection from '../generated/pwj208f1.json'; import { AcceptanceManifest } from '../types';
export const pwj208f1AcceptanceManifest = projection as AcceptanceManifest;
